<div id="bus_pol_model" class="know-more-sections">
    <div class="km-close-btn" (click)="Close()">
        <span class="clicktoclose"><i class="icon-k-close"></i></span>
    </div>



    <div class="km-gia-rang" class="no-select">
        <div class="container">
            <div class="row">
                
                <div class="gr-content-row bt-0" style="padding-top: 0;">
                    <div class="grc-txt-p">
                        <h1><b>{{ModalData}}</b></h1>
                    </div>

                    <div class="km-banner">
                        <img *ngIf="ModalData == 'MGT 7 2023'" src="/assets/img/MGT.png" alt="" class="img-responsive">
                        <img *ngIf="ModalData == 'Resolution Board of Directors'" src="/assets/img/ResolutionBoardofDirectors.png" alt="" class="img-responsive">
                    </div>

                    

                    <div class="grc-txt-p">
                        <h5 class="request_button" (click)="OpenRequestMGT()"><b>Request the complete {{ModalData}} document</b></h5>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>